<template>
  <div>
    <!-- New vocabulary  -->
    <div class="d-flex mt-5">
      <h4 class="my-2">新出語彙</h4>
      <v-spacer />
      <AddVocabulary @resetList="keyVocabularyList++" />
    </div>
    <p
      class="mb-0"
      v-for="(vocabulary, index) in vocabularyGrammar"
      :key="keyVocabularyList + index"
    >
      <v-chip class="ma-2">
        <span class="ml-3" style="white-space: pre-wrap">{{
          vocabulary["ja"]
        }}</span>
        <UpdateVocabulary
          :item="vocabulary"
          :index="index"
          @resetList="keyVocabularyList++"
        />
        <VocabularyDelete :index="index" @resetList="keyVocabularyList++" />
      </v-chip>
    </p>
  </div>
</template>
<script>
import AddVocabulary from "./AddVocabulary";
import VocabularyDelete from "./DeleteItemVocabulary";
import UpdateVocabulary from "./UpdateVocabulary";
// import { getListVocabulary } from "@/api/Vocabulary.api";
export default {
  store: ["vocabularyGrammar"],
  components: {
    AddVocabulary,
    VocabularyDelete,
    UpdateVocabulary,
  },
  data() {
    return {
      keyVocabularyList: 0,
    };
  },
};
</script>
<style scoped>
::v-deep .v-chip.v-size--default {
  height: auto !important;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>